module.exports = __webpack_public_path__ + "81b70172c32996977d788593b8ef6901.jpg";